var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputedit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M460.41 717.42L305 561.22l442.66-439.59 155.43 156.2zM1024 156.33L868.54.13l-86.33 86.78 155.43 156.2zM184.1 838.14l86.34-242.23 155.45 156.2zM784 515.66l-1.32 338.44c0 56.16-30.12 73.75-85.06 73.75H166.11c-55 0-70.08-16.11-70.08-71.54l.11-534.66c0-55.32 14-65.62 68.49-65.62h329.23L559.73 160h-427.1C41.71 160 0 197.31 0 289.65v614.66c0 92.53 58.37 119.56 150.11 119.56h563.51c91.74 0 164.59-44 164.59-137.77l1.52-438.2z"
  })));
}
export default SvgInputedit;